interface TOCProps {
  headings: { level: number; text: string; id: string }[];
}

export function TableOfContents({ headings }: TOCProps) {
  if (headings.length < 2) return null;

  return (
    <aside className="toc" aria-label="Table of contents">
      <h3 className="toc-title">On this page</h3>
      <ul className="toc-list">
        {headings
          .filter((h) => h.level >= 2 && h.level <= 4)
          .map((h) => (
            <li
              key={h.id}
              className={`toc-item toc-level-${h.level}`}
            >
              <a href={`#${h.id}`} className="toc-link">
                {h.text}
              </a>
            </li>
          ))}
      </ul>
    </aside>
  );
}
